export default "__VITE_ASSET__a902b379__"